export const AccessoriesState = {
	url: '/accessories/:consultationId',
	title: 'Accessories Items',
	template: '<accessories-page></accessories-page>',
	params: {
		consultationId: {
			type: 'path',
			squash: true,
		},
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "accessoriesPageMod" */
			'@Containers/builder-accessories-page/accessories-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPrivate({status: 'draft', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
	],
};

export const AccessoriesInspectorState = {
	url: '/inspector/:consultationId/:proposalId',
	title: 'Proposal Inspector',
	template: '<accessories-inspector-page></accessories-inspector-page>',
	params: {consultationId: null, proposalId: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "accessoriesInspectorPageMod" */
			'@Containers/builder-accessories-page/accessories-inspector-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
